import Breadcrumb from 'components/Common/Breadcrumb';
import PageLoader from 'components/Common/PageLoader';
import { ErrorMessage, Field, FieldArray, FormikProvider, useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button, Card, CardBody, Col, Form, FormFeedback, Input, Label, Row } from 'reactstrap';
import { addAirShiiperInfo, addSeaShipperInfo, getSeaShipperInfo } from 'store/actions';
import * as Yup from "yup"
import AsyncSelect from "react-select/async";
import { portData }  from "../../constants/port"

const SeaShipperInformationForm = ({ quote, shipperId }) => {
    const [portLoadingValue, setPortLoadingValue] = useState({label: '', value:''})
    const [portDischargeValue, setPortDischargeValue] = useState({label: '', value:''})
    const [portReceiptValue, setPortReceiptValue] = useState({label: '', value:''})
    const [portDeliveryValue, setPortDeliveryValue] = useState({label: '', value:''})
    const [validatePackageDetails, setvalidatePackageDetails] = useState(false)
    const history = useHistory()
    const dispatch = useDispatch()
    const { shipperData, loader } = useSelector(state => ({
        shipperData: state.GetSeaShipperInfo?.shipperInfo,
        loader: state.GetSeaShipperInfo
    }))
    const shipperForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            billOfLoadingNumber: '',
            placeOfReceipt: '',
            portOfLoading: '',
            vesselAndVoy: '',
            portOfDischarge: '',
            portOfDelivery: '',
            shipper: '',
            consignee: '',
            notify: '',
            notifyPartyTo: '',
            destinationAgentDetails: '',
            packageDetails: [{
                containerNumberOrType: '',
                noOfPkgs: '',
                descriptionOfTheGoods: '',
                grossWeight: '',
                netWeight: '',
                CBM: ''
            }],
            marksAndNumbers: '',
            status: '',
        },
        validationSchema: Yup.object({
            billOfLoadingNumber: Yup.string().required('Bill of lading number is required').max(30, 'Bill of lading number should not exceed 30 characters'),
            placeOfReceipt: Yup.string().required('Place of receipt is required').max(30, 'Place of receipt should not exceed 30 characters'),
            portOfLoading: Yup.string().required('Port of loading is required').max(30, 'Port of loading should not exceed 30 characters'),
            vesselAndVoy: Yup.string().required('Vessel and voy is required').max(30, 'Vessel and voy should not exceed 30 characters'),
            portOfDischarge: Yup.string().required('Port of discharge is required').max(30, 'Port of dicharge should not exceed 30 characters'),
            portOfDelivery: Yup.string().required('Port of delivery is required').max(30, 'Port of delivery should not exceed 30 characters'),
            shipper: Yup.string().required('Shipper is required').max(300, 'Shipper should not exceed 300 characters'),
            consignee: Yup.string().required('Consignee is required').max(300, 'Consignee should not exceed 300 characters'),
            notify: Yup.string().required('Notify is required').max(300, 'Notify should not exceed 300 characters'),
            notifyPartyTo: Yup.string().max(300, 'Notify party to should not exceed 300 characters'),
            destinationAgentDetails: Yup.string().required('Destination agent details is required').max(300, 'Destination agent details should not exceed 300 characters'),
            packageDetails: Yup.array().of(Yup.object().shape({
                containerNumberOrType: Yup.string().required('Container number or type is required').max(10, 'Container number or type should not exceed 10 characters'),
                noOfPkgs: Yup.string().required('Number of packages is required').max(3, 'Number of package should not exceed 3 characters'),
                descriptionOfTheGoods: Yup.string().required('Description of goods is required').max(300, 'Description of goods should not exceed 300 characters'),
                grossWeight: Yup.string().required('Gross weight is required').max(8, 'Gross weight should not exceed 8 characters'),
                netWeight: Yup.string().required('Net weight is required').max(8, 'Net weight should not exceed 8 characters'),
                CBM: Yup.string().required('CBM is required').max(8, 'CBM should not exceed 8 characters')
            })),
            marksAndNumbers: Yup.string().required('Marks and numbers is required').max(300, "Marks and numbers should not exceed 300 characters"),
        }),
        onSubmit: (values) => {
            const shipperInfo = {}
            shipperInfo["billOfLoadingNumber"] = values.billOfLoadingNumber;
            shipperInfo["placeOfReceipt"] = values.placeOfReceipt;
            shipperInfo["portOfLoading"] = values.portOfLoading;
            shipperInfo["vesselAndVoy"] = values.vesselAndVoy;
            shipperInfo["portOfDischarge"] = values.portOfDischarge;
            shipperInfo["portOfDelivery"] = values.portOfDelivery;
            shipperInfo["shipper"] = values.shipper;
            shipperInfo["consignee"] = values.consignee;
            shipperInfo["notify"] = values.notify;
            shipperInfo["notifyPartyTo"] = values.notifyPartyTo;
            shipperInfo["destinationAgentDetails"] = values.destinationAgentDetails;
            shipperInfo["packageDetails"] = values.packageDetails;
            shipperInfo["marksAndNumbers"] = values.marksAndNumbers;
            shipperInfo["status"] = values.status;
            shipperInfo["quoteId"] = quote?._id
            shipperInfo["isRead"] = false;
            if (shipperId) {
                shipperInfo["_id"] = shipperId;
                shipperInfo["siStatusId"] = shipperData?.shipperInfo?.siStatusId;
            }
            dispatch(addSeaShipperInfo(shipperInfo, history))
        },
    })

    useEffect(() => {
        let idx = shipperForm.values.packageDetails.length - 1
        if (
            shipperForm.values.packageDetails[idx].containerNumberOrType &&
            shipperForm.values.packageDetails[idx].noOfPkgs &&
            shipperForm.values.packageDetails[idx].descriptionOfTheGoods &&
            shipperForm.values.packageDetails[idx].grossWeight &&
            shipperForm.values.packageDetails[idx].netWeight &&
            shipperForm.values.packageDetails[idx].CBM
        ) setvalidatePackageDetails(true)
        else setvalidatePackageDetails(false)
    }, [shipperForm.values.packageDetails])

    const packageDetailsValidation = (condition) => {
        let index = shipperForm.values.packageDetails.length - 1
        shipperForm.setFieldTouched(`packageDetails.${index}.containerNumberOrType`, condition, condition)
        shipperForm.setFieldTouched(`packageDetails.${index}.noOfPkgs`, condition, condition)
        shipperForm.setFieldTouched(`packageDetails.${index}.descriptionOfTheGoods`, condition, condition)
        shipperForm.setFieldTouched(`packageDetails.${index}.grossWeight`, condition, condition)
        shipperForm.setFieldTouched(`packageDetails.${index}.netWeight`, condition, condition)
        shipperForm.setFieldTouched(`packageDetails.${index}.CBM`, condition, condition)

    }
    const handleAddContainer = (arrayHelpers) => {
        packageDetailsValidation(true)
        validatePackageDetails &&
            arrayHelpers.insert(shipperForm.values.packageDetails.length + 1,
                {
                    containerNumberOrType: '',
                    noOfPkgs: '',
                    descriptionOfTheGoods: '',
                    grossWeight: '',
                    netWeight: '',
                    CBM: ''
                })
    }

    useEffect(() => {
        if (shipperId)
            dispatch(getSeaShipperInfo(shipperId, history))
    }, [shipperId])

    useEffect(() => {
        if (shipperId && shipperData) {
            setFormValue()
        }
    }, [shipperData])

    const setFormValue = () => {
        shipperForm.setFieldValue("billOfLoadingNumber", shipperData?.shipperInfo?.billOfLoadingNumber)
        // shipperForm.setFieldValue("placeOfReceipt", shipperData?.shipperInfo?.placeOfReceipt)
        // shipperForm.setFieldValue("portOfLoading", shipperData?.shipperInfo?.portOfLoading)
        setPortReceipt(shipperData?.shipperInfo?.placeOfReceipt)
        setPortLoading(shipperData?.shipperInfo?.portOfLoading)
        setPortDischarge(shipperData?.shipperInfo?.portOfDischarge)
        setPortDelivery(shipperData?.shipperInfo?.portOfDelivery)
        shipperForm.setFieldValue("vesselAndVoy", shipperData?.shipperInfo?.vesselAndVoy)
        // shipperForm.setFieldValue("portOfDischarge", shipperData?.shipperInfo?.portOfDischarge)
        // shipperForm.setFieldValue("portOfDelivery", shipperData?.shipperInfo?.portOfDelivery)
        shipperForm.setFieldValue("shipper", shipperData?.shipperInfo?.shipper)
        shipperForm.setFieldValue("consignee", shipperData?.shipperInfo?.consignee)
        shipperForm.setFieldValue("notify", shipperData?.shipperInfo?.notify)
        shipperForm.setFieldValue("notifyPartyTo", shipperData?.shipperInfo?.notifyPartyTo)
        shipperForm.setFieldValue("destinationAgentDetails", shipperData?.shipperInfo?.destinationAgentDetails)
        shipperForm.setFieldValue("marksAndNumbers", shipperData?.shipperInfo?.marksAndNumbers)
        shipperForm.setFieldValue("status", shipperData?.shipperInfo?.status)
        shipperData?.shipperInfo?.packageDetails?.map((item, index) => {
            shipperForm.setFieldValue(`packageDetails.${index}.containerNumberOrType`, item.containerNumberOrType)
            shipperForm.setFieldValue(`packageDetails.${index}.noOfPkgs`, item.noOfPkgs)
            shipperForm.setFieldValue(`packageDetails.${index}.descriptionOfTheGoods`, item.descriptionOfTheGoods)
            shipperForm.setFieldValue(`packageDetails.${index}.grossWeight`, item.grossWeight)
            shipperForm.setFieldValue(`packageDetails.${index}.netWeight`, item.netWeight)
            shipperForm.setFieldValue(`packageDetails.${index}.CBM`, item.CBM)
        })
    }

    const loadOptions = async (inputValue) => {
        if (inputValue) {
            return await portData.filter((r) => r?.label.toLowerCase().startsWith(inputValue.toLowerCase()));
        } else {
            return await portData.slice(0, 100);
        }
    };

    const setPortLoading =(data) => {
        let value = portData?.filter((item) => item?.value === data)
        if (value) setPortLoadingValue(value)
        else setPortLoadingValue({ label: '', value: '' })
        shipperForm.setFieldValue("portOfLoading", data)
    }

    const setPortDischarge =(data) => {
        let value = portData?.filter((item) => item?.value === data)
        if (value) setPortDischargeValue(value)
        else setPortDischargeValue({ label: '', value: '' })
        shipperForm.setFieldValue("portOfDischarge", data)
    }

    const setPortReceipt =(data) => {
        let value = portData?.filter((item) => item?.value === data)
        if (value) setPortReceiptValue(value)
        else setPortReceiptValue({ label: '', value: '' })
        shipperForm.setFieldValue("placeOfReceipt", data)
    }

    const setPortDelivery =(data) => {
        let value = portData?.filter((item) => item?.value === data)
        if (value) setPortDeliveryValue(value)
        else setPortDeliveryValue({ label: '', value: '' })
        shipperForm.setFieldValue("portOfDelivery", data)
    }

    return (
        <div>
            {loader === true ? <PageLoader /> : null}
            <Breadcrumb title="Enquiries" dashurl="/enquiries" breadcrumbItem={`Sea shipper information for enquiry #${quote?.quoteNumber}`} breadcrumbName="Shipper information" />
            <FormikProvider value={shipperForm}>
                <Form
                    className="needs-validation"
                    encType="multipart/form-data"
                    onSubmit={e => {
                        e.preventDefault()
                        shipperForm.handleSubmit()
                        return false
                    }}>
                    <Card>
                        <CardBody>
                            <Row className='mb-4'>
                                <Col md='4'>
                                    <Label>Bill of lading number<span>*</span></Label>
                                    <Input
                                        name="billOfLoadingNumber"
                                        type="text"
                                        className="form-control"
                                        id="validationCustom01"
                                        onChange={shipperForm.handleChange}
                                        onBlur={shipperForm.handleBlur}
                                        value={shipperForm.values.billOfLoadingNumber || ""}
                                        invalid={shipperForm.touched.billOfLoadingNumber && shipperForm.errors.billOfLoadingNumber ? true : false}
                                    />
                                    {shipperForm.touched.billOfLoadingNumber &&
                                        shipperForm.errors.billOfLoadingNumber ? (
                                        <FormFeedback type="invalid">
                                            {shipperForm.errors.billOfLoadingNumber}
                                        </FormFeedback>
                                    ) : null}
                                </Col>
                                <Col md='4'>
                                    <Label>Place of receipt<span>*</span></Label>
                                    <div className={`position-relative drop-down ${shipperForm.touched.placeOfReceipt && shipperForm.errors.placeOfReceipt ? 'role' : ''}`}>
                                        <AsyncSelect className='form-control' value={portReceiptValue} cacheOptions defaultOptions loadOptions={loadOptions} onChange={(value)=>{
                                                setPortReceipt(value?.value)
                                        }}/>
                                    </div>
                                    {shipperForm.touched.placeOfReceipt && shipperForm.errors.placeOfReceipt ? (
                                        <span className="role-error invalid-feedback">{shipperForm.errors.placeOfReceipt}</span>
                                    ) : null}
                                    {/* <Input
                                        name="placeOfReceipt"
                                        type="text"
                                        className="form-control"
                                        id="validationCustom01"
                                        onChange={shipperForm.handleChange}
                                        onBlur={shipperForm.handleBlur}
                                        value={shipperForm.values.placeOfReceipt || ""}
                                        invalid={shipperForm.touched.placeOfReceipt && shipperForm.errors.placeOfReceipt ? true : false}
                                    />
                                    {shipperForm.touched.placeOfReceipt &&
                                        shipperForm.errors.placeOfReceipt ? (
                                        <FormFeedback type="invalid">
                                            {shipperForm.errors.placeOfReceipt}
                                        </FormFeedback>
                                    ) : null} */}
                                </Col>
                                <Col md='4'>
                                    <Label>Port of loading<span>*</span></Label>
                                    <div className={`position-relative drop-down ${shipperForm.touched.portOfLoading && shipperForm.errors.portOfLoading ? 'role' : ''}`}>
                                        <AsyncSelect className='form-control' value={portLoadingValue} cacheOptions defaultOptions loadOptions={loadOptions} onChange={(value)=>{
                                            setPortLoading(value?.value)
                                        }}/>
                                    </div>
                                    {shipperForm.touched.portOfLoading && shipperForm.errors.portOfLoading ? (
                                        <span className="role-error invalid-feedback">{shipperForm.errors.portOfLoading}</span>
                                    ) : null}
                                    {/* <Input
                                        name="portOfLoading"
                                        type="text"
                                        className="form-control"
                                        id="validationCustom01"
                                        onChange={shipperForm.handleChange}
                                        onBlur={shipperForm.handleBlur}
                                        value={shipperForm.values.portOfLoading || ""}
                                        invalid={shipperForm.touched.portOfLoading && shipperForm.errors.portOfLoading ? true : false}
                                    />
                                    {shipperForm.touched.portOfLoading &&
                                        shipperForm.errors.portOfLoading ? (
                                        <FormFeedback type="invalid">
                                            {shipperForm.errors.portOfLoading}
                                        </FormFeedback>
                                    ) : null} */}
                                </Col>
                            </Row>
                            <Row className='mb-4'>
                                <Col md='4'>
                                    <Label>Vessel & voy<span>*</span></Label>
                                    <Input
                                        name="vesselAndVoy"
                                        type="text"
                                        className="form-control"
                                        id="validationCustom01"
                                        onChange={shipperForm.handleChange}
                                        onBlur={shipperForm.handleBlur}
                                        value={shipperForm.values.vesselAndVoy || ""}
                                        invalid={shipperForm.touched.vesselAndVoy && shipperForm.errors.vesselAndVoy ? true : false}
                                    />
                                    {shipperForm.touched.vesselAndVoy &&
                                        shipperForm.errors.vesselAndVoy ? (
                                        <FormFeedback type="invalid">
                                            {shipperForm.errors.vesselAndVoy}
                                        </FormFeedback>
                                    ) : null}
                                </Col>
                                <Col md='4'>
                                    <Label>Port of discharge<span>*</span></Label>
                                    <div className={`position-relative drop-down ${shipperForm.touched.portOfDischarge && shipperForm.errors.portOfDischarge ? 'role' : ''}`}>
                                        <AsyncSelect className='form-control' value={portDischargeValue} cacheOptions defaultOptions loadOptions={loadOptions} onChange={(value)=>{
                                            setPortDischarge(value?.value)
                                        }}/>
                                    </div>
                                    {shipperForm.touched.portOfDischarge && shipperForm.errors.portOfDischarge ? (
                                        <span className="role-error invalid-feedback">{shipperForm.errors.portOfDischarge}</span>
                                    ) : null}
                                    {/* <Input
                                        name="portOfDischarge"
                                        type="text"
                                        className="form-control"
                                        id="validationCustom01"
                                        onChange={shipperForm.handleChange}
                                        onBlur={shipperForm.handleBlur}
                                        value={shipperForm.values.portOfDischarge || ""}
                                        invalid={shipperForm.touched.portOfDischarge && shipperForm.errors.portOfDischarge ? true : false}
                                    />
                                    {shipperForm.touched.portOfDischarge &&
                                        shipperForm.errors.portOfDischarge ? (
                                        <FormFeedback type="invalid">
                                            {shipperForm.errors.portOfDischarge}
                                        </FormFeedback>
                                    ) : null} */}
                                </Col>
                                <Col md='4'>
                                    <Label>Port of delivery<span>*</span></Label>
                                    <div className={`position-relative drop-down ${shipperForm.touched.portOfDelivery && shipperForm.errors.portOfDelivery ? 'role' : ''}`}>
                                        <AsyncSelect className='form-control' value={portDeliveryValue} cacheOptions defaultOptions loadOptions={loadOptions} onChange={(value)=>{
                                            setPortDelivery(value?.value)
                                        }}/>
                                    </div>
                                    {shipperForm.touched.portOfDelivery && shipperForm.errors.portOfDelivery ? (
                                        <span className="role-error invalid-feedback">{shipperForm.errors.portOfDelivery}</span>
                                    ) : null}
                                    {/* <Input
                                        name="portOfDelivery"
                                        type="text"
                                        className="form-control"
                                        id="validationCustom01"
                                        onChange={shipperForm.handleChange}
                                        onBlur={shipperForm.handleBlur}
                                        value={shipperForm.values.portOfDelivery || ""}
                                        invalid={shipperForm.touched.portOfDelivery && shipperForm.errors.portOfDelivery ? true : false}
                                    />
                                    {shipperForm.touched.portOfDelivery &&
                                        shipperForm.errors.portOfDelivery ? (
                                        <FormFeedback type="invalid">
                                            {shipperForm.errors.portOfDelivery}
                                        </FormFeedback>
                                    ) : null} */}
                                </Col>
                            </Row>
                            <Row className='mb-4'>
                                <Col md='6'>
                                    <Label>Shipper<span>*</span></Label>
                                    <Input
                                        name="shipper"
                                        type="textarea"
                                        className="form-control col-first"
                                        id="validationCustom01"
                                        onChange={shipperForm.handleChange}
                                        onBlur={shipperForm.handleBlur}
                                        value={shipperForm.values.shipper || ""}
                                        invalid={shipperForm.touched.shipper && shipperForm.errors.shipper ? true : false}
                                    />
                                    {shipperForm.touched.shipper &&
                                        shipperForm.errors.shipper ? (
                                        <FormFeedback type="invalid">
                                            {shipperForm.errors.shipper}
                                        </FormFeedback>
                                    ) : null}
                                </Col>
                                <Col md='6'>
                                    <Label>Consignee<span>*</span></Label>
                                    <Input
                                        name="consignee"
                                        type="textarea"
                                        className="form-control"
                                        id="validationCustom01"
                                        onChange={shipperForm.handleChange}
                                        onBlur={shipperForm.handleBlur}
                                        value={shipperForm.values.consignee || ""}
                                        invalid={shipperForm.touched.consignee && shipperForm.errors.consignee ? true : false}
                                    />
                                    {shipperForm.touched.consignee &&
                                        shipperForm.errors.consignee ? (
                                        <FormFeedback type="invalid">
                                            {shipperForm.errors.consignee}
                                        </FormFeedback>
                                    ) : null}
                                </Col>
                            </Row>
                            <Row className='mb-4'>
                                <Col md='6'>
                                    <Label>Notify party<span>*</span></Label>
                                    <Input
                                        name="notify"
                                        type="textarea"
                                        className="form-control col-first"
                                        id="validationCustom01"
                                        onChange={shipperForm.handleChange}
                                        onBlur={shipperForm.handleBlur}
                                        value={shipperForm.values.notify || ""}
                                        invalid={shipperForm.touched.notify && shipperForm.errors.notify ? true : false}
                                    />
                                    {shipperForm.touched.notify &&
                                        shipperForm.errors.notify ? (
                                        <FormFeedback type="invalid">
                                            {shipperForm.errors.notify}
                                        </FormFeedback>
                                    ) : null}
                                </Col>
                                <Col md='6'>
                                    <Label>Destination agent details<span>*</span></Label>
                                    <Input
                                        name="destinationAgentDetails"
                                        type="textarea"
                                        className="form-control"
                                        id="validationCustom01"
                                        onChange={shipperForm.handleChange}
                                        onBlur={shipperForm.handleBlur}
                                        value={shipperForm.values.destinationAgentDetails || ""}
                                        invalid={shipperForm.touched.destinationAgentDetails && shipperForm.errors.destinationAgentDetails ? true : false}
                                    />
                                    {shipperForm.touched.destinationAgentDetails &&
                                        shipperForm.errors.destinationAgentDetails ? (
                                        <FormFeedback type="invalid">
                                            {shipperForm.errors.destinationAgentDetails}
                                        </FormFeedback>
                                    ) : null}
                                </Col>
                            </Row>
                            <Row>
                                <Col md='6'>
                                    <Label>Other than notify party</Label>
                                    <Input
                                        name="notifyPartyTo"
                                        type="textarea"
                                        className="form-control col-first"
                                        id="validationCustom01"
                                        onChange={shipperForm.handleChange}
                                        onBlur={shipperForm.handleBlur}
                                        value={shipperForm.values.notifyPartyTo || ""}
                                        invalid={shipperForm.touched.notifyPartyTo && shipperForm.errors.notifyPartyTo ? true : false}
                                    />
                                    {shipperForm.touched.notifyPartyTo &&
                                        shipperForm.errors.notifyPartyTo ? (
                                        <FormFeedback type="invalid">
                                            {shipperForm.errors.notifyPartyTo}
                                        </FormFeedback>
                                    ) : null}
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardBody>
                            <FieldArray name='packageDetails' render={
                                (arrayHelpers) => {
                                    return <div>
                                        <h5 className='mb-4'>Container details</h5>
                                        {shipperForm.values.packageDetails.map((details, index) => (
                                            <div className='mt-2 position-relative' key={index}>
                                                <div className='close-icon float-end position-relative'>
                                                    <button className='btn close-btn' hidden={shipperForm.values.packageDetails.length > 1 ? false : true} type='button' onClick={() => arrayHelpers.remove(index)}><i className="mdi mdi-close"></i></button>
                                                </div>
                                                <div className='card'>
                                                    <div className='card-body'>
                                                        <Row>
                                                            <Col md='8'>
                                                                <Row className='mb-4'>
                                                                    <Col md='6'>
                                                                        <div className='form-group'>
                                                                            <Label>Container number or type<span>*</span></Label>
                                                                            <div className='array-element'>
                                                                                <Field
                                                                                    type='text'
                                                                                    className='form-control required-field'
                                                                                    name={`packageDetails.${index}.containerNumberOrType`}
                                                                                    id={`packageDetails.${index}.containerNumberOrType`}
                                                                                />
                                                                                <ErrorMessage
                                                                                    component='span'
                                                                                    className='field_error'
                                                                                    name={`packageDetails.${index}.containerNumberOrType`}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                    <Col md='6'>
                                                                        <div className='form-group'>
                                                                            <Label>Number of packages<span>*</span></Label>
                                                                            <div className='array-element'>
                                                                                <Field
                                                                                    onWheel={(e) => e.target.blur()}
                                                                                    type='number'
                                                                                    className='form-control required-field'
                                                                                    name={`packageDetails.${index}.noOfPkgs`}
                                                                                    id={`packageDetails.${index}.noOfPkgs`}
                                                                                />
                                                                                <ErrorMessage
                                                                                    component='span'
                                                                                    className='field_error'
                                                                                    name={`packageDetails.${index}.noOfPkgs`}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col md='4'>
                                                                        <div className='form-group'>
                                                                            <Label>Gross weight (kg)<span>*</span></Label>
                                                                            <div className='array-element'>
                                                                                <Field
                                                                                    onWheel={(e) => e.target.blur()}
                                                                                    type='number'
                                                                                    className='form-control required-field'
                                                                                    name={`packageDetails.${index}.grossWeight`}
                                                                                    id={`packageDetails.${index}.grossWeight`}
                                                                                />
                                                                                <ErrorMessage
                                                                                    component='span'
                                                                                    className='field_error'
                                                                                    name={`packageDetails.${index}.grossWeight`}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                    <Col md='4'>
                                                                        <div className='form-group'>
                                                                            <Label>Net weight (kg)<span>*</span></Label>
                                                                            <div className='array-element'>
                                                                                <Field
                                                                                    onWheel={(e) => e.target.blur()}
                                                                                    type='number'
                                                                                    className='form-control required-field'
                                                                                    name={`packageDetails.${index}.netWeight`}
                                                                                    id={`packageDetails.${index}.netWeight`}
                                                                                />
                                                                                <ErrorMessage
                                                                                    component='span'
                                                                                    className='field_error'
                                                                                    name={`packageDetails.${index}.netWeight`}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                    <Col md='4'>
                                                                        <div className='form-group'>
                                                                            <Label>CBM<span>*</span></Label>
                                                                            <div className='array-element'>
                                                                                <Field
                                                                                    onWheel={(e) => e.target.blur()}
                                                                                    type='number'
                                                                                    className='form-control required-field'
                                                                                    name={`packageDetails.${index}.CBM`}
                                                                                    id={`packageDetails.${index}.CBM`}
                                                                                />
                                                                                <ErrorMessage
                                                                                    component='span'
                                                                                    className='field_error'
                                                                                    name={`packageDetails.${index}.CBM`}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            <Col md='4'>
                                                                <div className='form-group'>
                                                                    <Label>Description of goods<span>*</span></Label>
                                                                    <Field component="div" name={`packageDetails.${index}.descriptionOfTheGoods`} className='array-element'>
                                                                        <Input
                                                                            name={`packageDetails.${index}.descriptionOfTheGoods`}
                                                                            type="textarea"
                                                                            className="form-control required-field"
                                                                            id={`packageDetails.${index}.descriptionOfTheGoods`}
                                                                            onChange={(e) => shipperForm.setFieldValue(`packageDetails.${index}.descriptionOfTheGoods`, e.target.value)}
                                                                            value={shipperForm.values.packageDetails[index].descriptionOfTheGoods || ""}
                                                                        />
                                                                    </Field>
                                                                    <ErrorMessage
                                                                        component='span'
                                                                        className='field_error'
                                                                        name={`packageDetails.${index}.descriptionOfTheGoods`}
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                        <div className='form-group float-end mt-2'>
                                            <button type={'button'} className='primary-button'
                                                onClick={() => handleAddContainer(arrayHelpers)}>Add Container</button>
                                        </div>
                                    </div>
                                }}>
                            </FieldArray>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardBody>
                            <Row>
                                <Col md='6'>
                                    <Label>Marks & numbers<span>*</span></Label>
                                    <Input
                                        name="marksAndNumbers"
                                        type="textarea"
                                        className="form-control"
                                        id="validationCustom01"
                                        onChange={shipperForm.handleChange}
                                        onBlur={shipperForm.handleBlur}
                                        value={shipperForm.values.marksAndNumbers || ""}
                                        invalid={shipperForm.touched.marksAndNumbers && shipperForm.errors.marksAndNumbers ? true : false}
                                    />
                                    {shipperForm.touched.marksAndNumbers &&
                                        shipperForm.errors.marksAndNumbers ? (
                                        <FormFeedback type="invalid">
                                            {shipperForm.errors.marksAndNumbers}
                                        </FormFeedback>
                                    ) : null}
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Row className='quotes-button-class justify-content-center mb-5'>
                        <Col className='text-center'>
                            <Button className='primary-button mx-1' type="submit" onClick={() => shipperForm.setFieldValue(`status`, `submitted`)}>
                                Submit to Admin
                            </Button>
                            {shipperId ? null : <Button className='btn btn-secondary btn-draft h-100 mx-1' type="submit" onClick={() => shipperForm.setFieldValue(`status`, `draft`)}>
                                Save as Draft
                            </Button>}
                            <Button className="secountry-btn mx-1" type="reset" onClick={() => {
                                if (shipperId) setFormValue()
                                else shipperForm.resetForm()
                            }}> Clear </Button>
                        </Col>
                    </Row>
                </Form>
            </FormikProvider>
        </div>
    )
}

export default SeaShipperInformationForm